@defer {
    <div class="as-panel as-panel--large as-columns">
        <asg-exam-properties-sidebar [activeSideTab]="messageKey" [isReadOnly]="isReadOnly"
            (eventClick)="handleChangeTab($event)"></asg-exam-properties-sidebar>
        <div class="as-panel-view-container">
            <asg-exam-properties-header></asg-exam-properties-header>
            <asg-exam-properties-view class="viewContainer" [activeSideTab]="messageKey" [isReadOnly]="isReadOnly"
                [prepExam]="prepExam" [examPropertiesType]="examPropertiesType" (goBackToUnlockCodeTab)="goToUnlockTab()"></asg-exam-properties-view>
            <asg-exam-properties-footer [activeSideTab]="messageKey" [isReadOnly]="isReadOnly"
            [prepExam]="prepExam" [examPropertiesType]="examPropertiesType" (eventClick)="clickNavigate($event)">
            </asg-exam-properties-footer>
        </div>
    </div>    
}
